/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { OrganizationsControllerRemoveMutationResponse, OrganizationsControllerRemovePathParams, OrganizationsControllerRemove401, OrganizationsControllerRemove403, OrganizationsControllerRemove404 } from "../../models/organizationsController/OrganizationsControllerRemove";

function getOrganizationsControllerRemoveUrl(id: OrganizationsControllerRemovePathParams["id"]) {
  const res = { method: 'DELETE', url: `/api/v1/organizations/${id}` as const }  
  return res
}

/**
 * @summary Delete an organization
 * {@link /api/v1/organizations/:id}
 */
export async function organizationsControllerRemove(id: OrganizationsControllerRemovePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<OrganizationsControllerRemoveMutationResponse, ResponseErrorConfig<OrganizationsControllerRemove401 | OrganizationsControllerRemove403 | OrganizationsControllerRemove404>, unknown>({ method : "DELETE", url : getOrganizationsControllerRemoveUrl(id).url.toString(), ... requestConfig })  
  return res.data
}